import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

// Contexto para la config pública de la Tienda Online (WhatsApp, slogan, etc.)
// Fuente única de verdad: GET /api/public/landing-config
// Se actualiza al montar el layout y todos los componentes del sitio público la consumen.

const DEFAULT_CFG = {
  whatsapp: "50243036012",
  hero_titulo: "COMPLETA TU CASA, COMPLETA TU VIDA",
  hero_subtitulo: "",
  hero_slogan: "Nuestra oferta principal",
};

const PublicConfigContext = createContext(DEFAULT_CFG);

export function PublicConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_CFG);
  useEffect(() => {
    let alive = true;
    api.get("/public/landing-config")
      .then(({ data }) => {
        if (!alive || !data) return;
        setConfig((prev) => ({
          ...prev,
          ...data,
          whatsapp: (data.whatsapp || prev.whatsapp || "").replace(/\D/g, "") || prev.whatsapp,
        }));
      })
      .catch(() => { /* mantener defaults */ });
    return () => { alive = false; };
  }, []);
  return <PublicConfigContext.Provider value={config}>{children}</PublicConfigContext.Provider>;
}

export function usePublicConfig() {
  return useContext(PublicConfigContext);
}
